// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__i7Io-","left":"styles_left__2eklu","desktopActions":"styles_desktopActions__LkGzh","title":"styles_title__1FB9_"};